module.exports = "/src/views/player/help/images/2472.jpg";